import { CommentsField } from "@/shared/components/CommentsField";
import { ButtonWithLoading, MesfModal } from "@dexteel/mesf-core";
import { Button, Typography } from "@mui/material";
import { useState } from "react";

type Props = {
	open: boolean;
	onClose: () => void;
	onConfirm: (comments: string | null) => void;
	isLoading: boolean;
	title: string;
	description: string;
	confirmButtonText: string;
	confirmButtonColor?:
		| "primary"
		| "secondary"
		| "error"
		| "warning"
		| "success";
};

export const ConfirmActionModal = ({
	open,
	onClose,
	onConfirm,
	isLoading,
	title,
	description,
	confirmButtonText,
	confirmButtonColor = "primary",
}: Props) => {
	const [comments, setComments] = useState("");

	const handleConfirm = () => {
		onConfirm(comments.trim() || null);
	};

	const handleClose = () => {
		if (!isLoading) {
			setComments("");
			onClose();
		}
	};

	return (
		<MesfModal
			open={open}
			handleClose={handleClose}
			title={title}
			maxWidth="sm"
			fullWidth
			PaperProps={{
				sx: { borderRadius: 2 },
			}}
		>
			<MesfModal.Content data-test-id="confirm-action-modal">
				<Typography>{description}</Typography>
				<CommentsField
					value={comments}
					onChange={(comment) => setComments(comment)}
				/>
			</MesfModal.Content>
			<MesfModal.Actions sx={{ px: 3, pb: 2 }}>
				<Button
					data-test-id="confirm-action-cancel-button"
					onClick={handleClose}
					disabled={isLoading}
					variant="outlined"
				>
					Cancel
				</Button>
				<ButtonWithLoading
					data-test-id="confirm-action-button"
					onClick={() => {
						setComments("");
						handleConfirm();
					}}
					isLoading={isLoading}
					variant="contained"
					color={confirmButtonColor}
				>
					{isLoading ? "Processing..." : confirmButtonText}
				</ButtonWithLoading>
			</MesfModal.Actions>
		</MesfModal>
	);
};
